
export function siteName (site) {
    return ((site?.name ?? site?.site_details?.site_name) ?? site?.site_name) ?? 'Not Available'
}
export function siteCity (site) {
    return site?.site_details?.city ?? (site.city ?? '')
}

export function siteState (site) {
    return site?.site_details?.state ?? (site?.state ?? '')
}

export function siteZip(site) {
    return site?.site_details?.zipcode ?? (site?.zipcode ?? '') 
}

export function siteAddress(site) {
    return site?.site_details?.address ?? (site?.address ?? '')
}

export function siteCSZCombo (site) {
    return `${siteCity(site)} ${siteState(site)} ${siteZip(site)}`.trim()
}

export function siteAccessCode(site) {
    return site?.access_code ?? '';
}
function isdigits (st) {
    return /^\d+$/.test(st)
}
export function validAccessCode(site) {
    const ac = siteAccessCode (site)
    return ac && ac.length === 11 && isdigits(ac)
}
export function grantAccessCode(grant) {
    return grant?.access_code ?? ''
}
export function sensorConfig (site) {
    return site?.site_details?.sensors
}
export function siteLastContact(site) {
    const deref = site?.site_details
    if (deref) {
        return deref?.last_msg_receive_time
    }
    return site?.last_msg_receive_time ?? null
}
export function siteGeoCode(site) {
    let geo = siteGeoLocation(site)
    if (!geo) {
        const strCoords = site?.site_details?.geo_location ?? site?.geo_location;
        if (strCoords) {
            const arrStr = strCoords.split(",")
            if (arrStr.length === 2) {
                const lat = parseFloat(arrStr[0]);
                const long = parseFloat(arrStr[1]);
                geo = [lat, long]
                site.geoCode = geo
            }
        }
    }
    return geo;
}

export function siteGeoLocation(site) {
    return site?.geoCode;
}
export function siteTZ(site, fallback='UTC') {
    return site?.site_details?.utc_offset ?? (site?.utc_offset ?? fallback)
}
export function siteFw(site) {
    return site?.site_details?.fw_version ?? (site?.fw_version ?? '');
}
export function siteDCAPType (site) {
    return site?.site_details?.tsm_dcap_type ?? siteFw(site)
}
export function sitePropertyId(site) {
    return site?.site_details?.property_id ?? (site?.property_id ?? '');
}
export function credentials (site) {
    const n = site.hasOwnProperty('sqlUserName') ? site.sqlUserName : '';
    const p = site.hasOwnProperty('sqlPassword') ? site.sqlPassword : '';
    return n+p;     //complete
}
export function grantName (grant) {
    return grant?.name ?? 'Not Available';
}

export function grantCity (grant) {
    return grant?.city ?? '';
}

export function grantState (grant) {
    return grant?.state ?? '';
}

export function grantZip(grant) {
    return grant?.zipcode ?? '';
}

export function grantAddress(grant) {
    return grant?.address ?? ''
}

export function grantCSZ (grant) {
    return `${grantCity(grant)} ${grantState(grant)} ${grantZip(grant)}`.trim()
}
export function dailyEmails (site) {
    return site?.daily_email_adrs ?? []
}
export function dailyRptTime(site) {
    return site?.daily_report_tod ?? ''
}
export function dailyReportName(site) {
    return site?.script_name
}
export function ownerRBC(site) {
    return site?.site_details?.ownerRBC
}
export function urlSiteList()
{
    return '/tehama/site-list-server'
}
function urlSiteCore(){
    return '/tehama/sites?frc_array=true&basic_data=true'
}
export function urlSites (aclist=undefined) {
    const uriOpt = aclist ? '&ac_list='+encodeURI(aclist) : ''
    return urlSiteCore()+uriOpt;
}
export function urlPageSites(acStart='') {
    const opt = acStart ? '&ac_start='+acStart : acStart
    return urlSiteCore()+opt;
}